// extracted by mini-css-extract-plugin
module.exports = {"tags":"ConferenceTags_tags__o1Y4W","tag":"ConferenceTags_tag__VnDKC"};